module.exports = __webpack_public_path__ + "static/media/navidad14.7e9ecebe.webp";